<template>
    <div>
        <div class="flex_b pad14" id="toolH">
            <div class="flex">
                <el-button v-if="isUse==0" :class="baseerp+'btn'"  size="small" type="primary" @click="addKp">新增</el-button>
                <!--<el-select style="width: 145px" @change="changeState"  class="marr4" v-model="i_state" size="small"  filterable placeholder="">
                    <el-option
                            v-for="item in stateData"
                            :key="item.i_state"
                            :label="item.vc_name"
                            :value="item.i_state">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" @change="changeCom" @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="small" clearable filterable placeholder="请选择交易公司">
                    <el-option
                            v-for="item in compsData"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" @change="changetype" class="marr4" v-model="i_type" size="small" filterable placeholder="请选择">
                    <el-option
                            v-for="item in typeList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" class="marr4" @change="changely" @clear="clearsearch('ly')" v-model="i_invoice_source" size="small" clearable filterable placeholder="来源">
                    <el-option
                            v-for="item in lyList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-date-picker
                        v-if="i_state!=0"
                        style="width: 220px"
                        class="marr4"
                        size="small"
                        v-model="valuetime"
                        @change="getTimes"
                        :clearable="false"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
                <el-input
                        style="width: 220px"
                        class="marr4"
                        size="small"
                        placeholder="搜索"
                        clearable
                        v-model="vc_search">
                </el-input>
                <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
                <el-button v-if="i_state==0" :class="baseerp+'btn'"  size="small" type="primary" @click="addKp">添加开票</el-button>
                <el-button v-if="i_state==0" :class="baseerp+'btn'"  size="small" type="primary" @click="editRow">编辑</el-button>
                <el-button v-if="i_state==0" :class="baseerp+'btn'"  size="small" type="primary" @click="saveRows">保存</el-button>-->
            </div>
        </div>
        <el-table
                border
                v-if="showTable"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @select="getselect"
                @selection-change="handleSelectionChange"
                v-loading="loading"
                size="mini"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-selection-row="true"
                :highlight-current-row="true"
                :row-class-name="rowClassName"
                @row-click="rowClick">
            <!--<el-table-column
                    v-if="i_state==0||i_state==1"
                    type="selection"
                    width="45">
            </el-table-column>-->
            <el-table-column
                    :label="$t('form_serial_number')"
                    type="index"
                    width="55">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_khname"
                    label="客户"
                    width="180">
            </el-table-column>-->
            <!--<el-table-column
                    prop="i_invoice_source"
                    label="发票来源"
                    width="100">
                <template slot-scope="scope">
                    <span>{{scope.row.i_invoice_source==1?'数税云':'线下'}}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="i_title_type"
                    label="发票抬头"
                    show-overflow-tooltip
                    width="120">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" style="width: 80px"  @change="changeTt"  class="marr4" v-model="scope.row.i_title_type" size="mini" filterable >
                       <el-option
                                v-for="item in titleType"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.i_title_type==1?'企业':'个人'}}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_invoice_type"
                    label="发票种类"
                    show-overflow-tooltip
                    width="170">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" style="width: 140px" @change="changeInvoice(scope.row)" class="marr4" v-model="scope.row.i_invoice_type" size="mini" filterable >
                        <el-option
                                v-for="item in kplxData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.vc_invoice_type}}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="typeTxt"
                    label="发票类型"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    v-if="i_state==-1"
                    prop="vc_relateinvoice_code"
                    label="关联发票号码"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_xcode"
                    label="销售编号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_pz_invoicename"
                    label="开票品名"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_kpname_sell"
                    label="开票品名"
                    show-overflow-tooltip
                    width="110">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_kpname_sell">
                    </el-input>
                    <span v-else>{{scope.row.vc_kpname_sell}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_pzspecs"
                    label="规格型号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kpbzstyle_sell"
                    label="开票规格"
                    show-overflow-tooltip
                    width="140">
                <template slot-scope="scope" >
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_kpbzstyle_sell">
                    </el-input>
                    <span v-else>{{scope.row.vc_kpbzstyle_sell}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="数量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_kpnum_sell"
                    label="开票数量"
                    show-overflow-tooltip
                    width="125">
                <template slot-scope="scope" >
                    <el-input-number v-if="scope.row.edit" @change="changenum(scope.row)" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"  size="mini" v-model="scope.row.f_kpnum_sell" ></el-input-number>
                    <span v-else>{{scope.row.f_kpnum_sell}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="55"
                    prop="vc_unit"
                    label="单位"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kpunit_sell"
                    label="开票单位"
                    show-overflow-tooltip
                    width="128">
                <template slot-scope="scope">
                    <el-select v-if="scope.row.edit" style="width: 100px" @focus="getUnits(scope.row)"  @change="changeData(scope.row)"  class="marr4" v-model="scope.row.vc_kpunit_sell" size="mini" clearable filterable placeholder="请选择开票单位">
                        <el-option
                                v-for="item in unitData"
                                :key="item.vc_unitsconvert"
                                :label="item.vc_unitsconvert"
                                :value="item.vc_unitsconvert">
                        </el-option>
                    </el-select>
                    <span v-else>{{scope.row.vc_kpunit_sell}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_price"
                    label="订单单价"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_kpprice_sell"
                    label="开票单价"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_amount"
                    label="开票金额"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_price_notax"
                    label="无税单价"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_amount_notax"
                    label="无税金额"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_sl"
                    label="税率"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_amount_tax"
                    label="税额"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_note"
                    label="发票备注"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    label="销售方"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kduname"
                    label="业务"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_lruname"
                    label="开单人"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_creditcode"
                    label="客户纳税人识别号"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_adress"
                    label="地址"
                    show-overflow-tooltip
                    width="170">
                <template slot-scope="scope">
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_address">
                    </el-input>
                    <span v-else style="margin-left: 10px">{{ scope.row.vc_address}}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_tel"
                    label="电话"
                    show-overflow-tooltip
                    width="170">
                <template slot-scope="scope">
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_tel">
                    </el-input>
                    <span v-else style="margin-left: 10px">{{scope.row.vc_tel }}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="address"
                    label="开户行"
                    show-overflow-tooltip
                    width="170">
                <template slot-scope="scope">
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_bank">
                    </el-input>
                    <span v-else style="margin-left: 10px">{{ scope.row.vc_bank}}</span>
                </template>
            </el-table-column>-->
           <!-- <el-table-column
                    prop="address"
                    label="开户行帐号"
                    show-overflow-tooltip
                    width="170">
                <template slot-scope="scope">
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_bank_account">
                    </el-input>
                    <span v-else style="margin-left: 10px">{{scope.row.vc_bank_account }}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    prop="vc_email"
                    label="邮箱"
                    show-overflow-tooltip
                    width="170">
                <template slot-scope="scope">
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_email">
                    </el-input>
                    <span v-else style="margin-left: 10px">{{scope.row.vc_email }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_note"
                    :label="$t('form_notes')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input v-if="scope.row.edit" class="wid100" size="mini"  v-model="scope.row.vc_note">
                    </el-input>
                    <span v-else style="margin-left: 10px">{{scope.row.vc_note }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    label="申请人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_applytime"
                    label="申请时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_state"
                    label="开票状态"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.i_state==0?'待提交':(scope.row.i_state==1?'已提交':'已开票') }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="dt_invoicetime"
                    label="开票时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_invoice_code"
                    label="发票代码"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    v-if="i_state==2||i_state==-1"
                    prop="vc_file"
                    label="附件"
                    show-overflow-tooltip
                    width="55px">
                <template slot-scope="scope">
                    <a :href="scope.row.vc_file" target="_blank">
                        <i class="el-icon-paperclip" v-show="scope.row.vc_file"></i>
                    </a>
                </template>
            </el-table-column>
            <!--v-if="i_state!=2&&i_state!=-1"-->
            <el-table-column label="操作" width="50"  v-if="isUse==0">
                <template slot-scope="scope">
                    <el-button size="mini" style="color: red"
                               type="text"
                               @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
            <!--<el-table-column label="发送业务" width="80"  >
                <template slot-scope="scope">
                    <el-button size="mini" style="color: red"
                               type="text" v-if="i_state==2"
                               @click="sendMessage(scope.$index, scope.row)">重发</el-button>
                </template>
            </el-table-column>-->
        </el-table>
        <el-pagination
                v-if="i_state==2||i_state==-1"
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div class="flex_b alc mar9" v-else>
            <div>
<!--                {{'已选'+ ' '+multipleSelection.length+' '+'条'}}-->
            </div>
            <div class="flex alc" v-if="isUse==0">
                <div class="marr4">
<!--                    <div style="color: #9e9e9e;font-size: 12px">{{'开票总额'}}</div>-->
<!--                    <div>{{totalPrice}}</div>-->
                </div>
<!--                <el-button :class="baseerp+'btn'" v-if="i_state==0" @click="kpsubmit('1')"  size="small" type="primary">提交开票</el-button>-->
<!--                <el-button :class="baseerp+'btn'" v-if="i_state==1" @click="kpsubmit('2')"  size="small" type="primary">作废提交</el-button>-->
                <el-button :class="baseerp+'btn'" size="small" type="primary" @click="saveOrder">{{$t('button_save')}}</el-button>
                <el-button :class="baseerp+'btn'" size="small" type="primary" @click="sureOver">完结</el-button>
            </div>
        </div>
        <!--dialog-->
        <!--<div class="cgdia">-->
            <el-dialog
                    :class="baseerp+'div'"
                    width="80%"
                    height=""
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible"
                    :append-to-body="true">
                <fore-kp :Data="Data" @cancelDialog="cancelDialog" @bbSheet="bbSheet"></fore-kp>
            </el-dialog>
        <!--</div>-->
        <div>
            <reportdialog  ref="mydialog"  ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import foreKp from "./foreKp";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        name: 'saleInvoicing',
        props:{
            orderData:{
                type:Object,
                required:true
            }
        },
        components:{
            foreKp,
            eDialog,
            reportdialog,
        },
        data() {
            return {
                isUse:null,
                del:[],
                activePage:"report/res/spread.vue",
                i_invoice_source:0,
                lyList:[{i_id:1,vc_name:'数税云'},{i_id:2,vc_name:'线下'},{i_id:0,vc_name:'全部'}],
                titleType:[{i_id:1,vc_name:'企业'},{i_id:2,vc_name:'个人'}],
                kpData:[],
                kplxData:[],
                copyvaildnum:0,
                unitData:[],
                showTable:true,
                baseerp:"",
                mid:0,
                loading:true,
                tableHeight:0,
                title:"新增关联订单",
                cshtitle:"已开票列表",
                dialogVisible:false,
                cshdialogVisible:false,
                Data:{},
                cshData:{},
                totalPrice:0,
                stateData:[
                    { i_state:0,vc_name:'待提交'},
                    { i_state:1,vc_name:'已提交'},
                    { i_state:2,vc_name:'已开票'},
                    { i_state:-1,vc_name:'已冲红'},
                ],
                i_state:0,
                compsData:[],
                companyName:'',
                companyId:0,
                vc_search:"",
                pageSize:999,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                tableData: [],
                multipleSelection: [],
                i_type:1,
                typeList:[{i_id:1,vc_name:'蓝字'},{i_id:2,vc_name:'红字'}]
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            i_state(){
                // console.log(this.i_state,'i_state')
                this.refreshTable();
            },
            vc_unit(){
                //console.log(this.vc_unit,'vc_unit')
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            //console.log(this.orderData,'this.orderData')
            this.isUse=this.orderData.isUse;
            this.baseerp=baseerp;
        //    this.invoicetype();
            this.getList();
            //this.getfMou();
        //    this.getCompanyList();
            this.$nextTick(function () {
                this.onResize();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                // console.log(n.h,this.tableHeight)
            },
            sureOver(){
                this.$confirm('确认完结后该发票不可继续关联销售订单，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.over()
                }).catch(() => {

                });
            },
            //重发
            async over(val){
                this.disabled=true;
                this.loading=true;
                let param={
                    recordId:this.orderData.recordId,
                };
                let res=await API.over(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            saveOrder(){
                this.saveGlSq()
            },
            //保存
            async saveGlSq(){
                this.disabled=true;
                this.loading=true;
                let param={
                    delSub:this.del,
                    invoiceNum:this.orderData.invoiceNum,
                    electronicNumber:this.orderData.electronicNumber,
                    recordId:this.orderData.recordId,
                    vc_file:this.orderData.invoiceFile,
                    list:this.tableData
                };
                let res=await API.saveGlSq(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            bbSheet(arg){
                //console.log('arg',arg)
                if(arg.i_gsid==0){
                    this.$message.error('请先选择公司!');
                    return;
                }
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({
                    title:"导出",
                    parm:{
                        type:'invoiceApplyRpt',
                        mid:this.$route.meta.mid,
                        arg:{
                            "i_gsid": arg.i_gsid,
                            "vc_search": arg.vc_search,
                            'dt_startdate':arg.dt_startdate,
                            'dt_enddate':arg.dt_enddate,
                        }},
                    w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })
            },
            changeTt(e){
                //console.log('e',e)
                this.i_title_type=e;
                this.kplxData = [];
                this.kplxData = this.i_title_type==2?this.kpData.filter(kp=>kp.i_isspec==0):this.kpData
                //console.log(this.kplxData ,'this.kplxData--- ')
            },
            //开票类型
            async invoicetype(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.invoicetype(param);
                if (res.code == 1) {
                    this.kpData = res.data.list;
                    this.kplxData = this.kpData;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changenum(e){
                //console.log('e',e.f_kpnum_sell)
                if(e.f_kpnum_sell>this.tableData[e.index].f_validnum||e.f_kpnum_sell==0){
                    this.$message.error('编辑开票数量不可大于原开票数量！');
                    this.tableData[e.index].f_kpnum_sell =this.tableData[e.index].f_validnum;
                    this.tableData[e.index].f_num = this.tableData[e.index].f_validnum / 1
                    this.$set(this.tableData,e.index,e)
                }else{
                    this.tableData[e.index].f_kpnum_sell = e.f_kpnum_sell;
                    let price = this.tableData[e.index].f_kpnum_sell * this.tableData[e.index].f_kpprice_sell;
                    this.tableData[e.index].f_amount = Math.round(parseFloat(price) * 100) / 100;
                    this.tableData[e.index].f_num = this.tableData[e.index].f_kpnum_sell / this.tableData[e.index].f_bl
                    /*let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                    this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;*/
                    this.$set(this.tableData,e.index,e)
                }
                //console.log( this.tableData[e.index].f_num,' this.tableData[e.index].f_num')

            },
            rowClick(row){
                /*if (row.edit) {
                    this.chooseRow = row
                    this.chooseIndex = row.index
                }
                console.log(row, row.index,'row')*/
            },
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            saveRows(){
                if(this.multipleSelection.length!=0&&this.Edit){
                    this.Edit=false;
                    //console.log(this.multipleSelection)
                    //return;
                    this.updInvoice()
                }else{
                    this.$message.warning('请编辑后保存!')
                }

            },
            //批量编辑待提交
            async updInvoice(){
                this.loading=true;
                let param={
                    updList:this.multipleSelection,
                };
                //return;
                let res=await API.updInvoice(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            editRow(){
                //console.log(this.Edit)
                if(this.multipleSelection.length!=0){
                    this.Edit=!this.Edit;
                    //console.log(this.multipleSelection)
                    this.multipleSelection.map(item=>{
                        this.tableData[item.index].edit=true
                    })
                    if(!this.Edit){
                        this.getList();
                    }
                    //this.$set(this.tableData,this.chooseRow.index,this.chooseRow)
                }else{
                    this.$message.warning('请选择要编辑的数据')
                }

            },
            changeInvoice(e){
                //console.log(this.kplxData,'this.kplxData');
                //console.log(e,'e');
                this.tableData[e.index].i_invoice_type=e.i_invoice_type;
                let choo = this.kplxData.filter(item=>{
                    return item.i_id == e.i_invoice_type
                });
                //console.log(choo,'choo');
                if(choo.length>0){
                    //this.i_isspec=choo[0].i_isspec;
                    this.tableData[e.index].vc_invoice_type=choo[0].vc_name;
                }else{
                    //this.i_isspec=null;
                    this.tableData[e.index].vc_invoice_type='';
                }
            },
            getUnits(row){
                //console.log(row,'22222');
                this.copyvaildnum=row.f_num;
                this.getUnitList(row.vc_unit);
            },
            changeData(e){
                //console.log(e.vc_kpunit_sell);
                //this.formData.vc_kpunit_sell=e;
                if(this.unitData.length!=0){
                    let choo = this.unitData.filter(item=>{
                        return item.vc_unitsconvert == e.vc_kpunit_sell
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].f_bl=choo[0].f_bl;
                        let f_kpprice_sell = this.tableData[e.index].f_price / choo[0].f_bl;
                        //console.log('f_kpprice_sell',f_kpprice_sell)
                        this.tableData[e.index].f_kpprice_sell = Math.round(parseFloat(f_kpprice_sell) * 100) / 100;
                        let validnum =0;
                        validnum=this.copyvaildnum*choo[0].f_bl;
                        //console.log('validnum',validnum)
                        this.tableData[e.index].f_validnum =validnum;
                        this.tableData[e.index].f_kpnum_sell=this.tableData[e.index].f_validnum;

                        //let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                    }else{
                        this.tableData[e.index].f_bl=1;
                        this.tableData[e.index].f_kpprice_sell = this.tableData[e.index].f_price*1;
                        this.tableData[e.index].f_validnum =this.copyvaildnum;
                        this.tableData[e.index].f_kpnum_sell=this.copyvaildnum;
                        this.tableData[e.index].vc_kpunit_sell=this.tableData[e.index].vc_unit;
                        //let price = this.formData.f_amount / this.formData.f_kpnum_sell;
                        //this.formData.f_kpprice_sell = Math.round(parseFloat(price) * 100) / 100;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }

            },
            //单位换算
            async getUnitList(vc_unit){
                let param = {
                    i_mid:this.mid,
                    vc_originunit:vc_unit,
                };
                let res = await API.getUnitList(param);
                if (res.code == 1) {
                    this.unitData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            kpsubmit(val){
                // console.log(this.multipleSelection,'this.multipleSelection')
                if(this.multipleSelection.length==0){
                    this.$message.error('请选择开票订单！');
                    return;
                }else{
                    if(val=='1'){
                        this.submit(this.multipleSelection)
                    }
                    if(val=='2'){
                        this.cancelsubmit(this.multipleSelection)
                    }
                }


            },
            //删除提交
            async cancelsubmit(id){
                this.disabled=true;
                this.loading=true;
                let alist=[];
                    id.map(item=>{
                        alist.push(item.i_id);
                    })
                let param={
                    ids:alist,
                };
                //console.log(param)
                //return
                let res=await API.cancelsubmit(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.getList();
                    this.$message.error(res.message);
                }
            },
            //提交
            async submit(id){
                this.disabled=true;
                this.loading=true;
                let alist=[];
                    id.map(item=>{
                        alist.push(item.i_id);
                    })
                let param={
                    ids:alist,
                };
                //console.log(param)
                //return
                let res=await API.submit(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.getList();
                    this.$message.error(res.message);
                }
            },
            cshFun(){
                this.cshData={
                    "i_gsid": this.companyId,
                };
                this.cshdialogVisible=true;
            },
            addKp(){
                /*if(this.companyId==0){
                    this.$message.error('请先选择公司!');
                    return;
                }
                this.Data={
                    "i_gsid": this.companyId,
                };*/
                //console.log(this.tableData,'this.tableData')
                let data = this.tableData.filter(item=>item.i_id==0)
                let map={
                    orderData:this.orderData,
                    select:data,
                }
                this.Data=map;
                this.dialogVisible=true;
            },
            cancelDialog(val){
                //console.log('val',val);
                this.Data={};
                this.dialogVisible=false;
                if(val){
                    if(val.addArr.length>0){
                        val.addArr.map(item=>{
                            item.i_id=0
                        })
                        this.tableData=[...this.tableData , ...val.addArr]
                    }
                    if(val.deleteArr.length>0){
                        val.deleteArr.map(item=>{
                            let idx=0;
                            let delidx=0;
                            idx = this.tableData.findIndex(tabitem=>{
                                return  tabitem.uniqueKey == item.uniqueKey
                            })
                            delidx = this.del.findIndex(tabitem=>{
                                return  tabitem == item.i_id
                            })
                            if(idx!=-1){
                                this.tableData.splice(idx,1)
                            }
                            if(delidx==-1){
                                if(item.i_id!=0){
                                    this.del.push(item.i_id)
                                }

                            }
                        })
                        //console.log(this.tableData,'this.tableData')
                        //console.log(this.del,'this.del')
                    }
                    return
                    this.i_state=0;
                    this.currentPage=1;
                    this.pageSize=999;
                    this.tableData=[];
                    this.dt_startdate='';
                    this.dt_enddate='';
                    this.getList();
                }
            },
            cshcancelDialog(val){
                //console.log('val',val);
                this.cshData={};
                this.cshdialogVisible=false;
                if(val=='new'){
                    this.i_state=0;
                    this.currentPage=1;
                    this.pageSize=999;
                    this.tableData=[];
                    this.dt_startdate='';
                    this.dt_enddate='';
                    this.getList();
                }
            },
            sendMessage(index, row){
                this.$confirm('是否重发','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.sendMsg(row.vc_invoice_code)
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            handleDelete(index, row){
                this.$confirm('是否删除该数据','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    //this.saveForm(row.i_id)
                    if(row.i_id!=0){
                        this.del.push(row.i_id)
                    }
                    this.tableData.splice(index,1)
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            //重发
            async sendMsg(val){
                this.disabled=true;
                this.loading=true;
                let param={
                    vc_invoice_code:val
                };
                let res=await API.sendMsg(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    // this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //保存
            async saveForm(id){
                let alist=[];
                alist.push(id);
                this.disabled=true;
                this.loading=true;
                let param={
                    delSub:alist,
                    list:[],
                };
                let res=await API.saveInvoice(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList();
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            getselect(val,row){
                //console.log(val,row);

            },
            handleSelectionChange(val) {
                if(this.i_state==0||this.i_state==1){
                    // console.log(val,'val')
                    this.multipleSelection = val;
                    //let totalP = 123.126846523;
                    let totalP = 0;
                    val.map(item=>{
                        totalP += item.f_amount
                    });
                    this.totalPrice = Math.round(parseFloat(totalP) * 100) / 100;
                }

            },
            //获取交易公司
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.mid,'this.m!!!!!!!!!')
                let param = {
                    vc_search:'',
                    page_count:1,
                    page_size:999,
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changely(e){
                this.i_invoice_source=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changeCom(e){
                // console.log(e);
                this.companyId=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changetype(e){
                // console.log(e);
                this.i_type=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changeState(e){
                // console.log(e,'?????');
                this.totalPrice=0;
                this.i_state=e;
                if(this.i_state==0||this.i_state==1){
                    this.currentPage=1;
                    this.pageSize=999;
                    this.dt_startdate='';
                    this.dt_enddate='';
                    //this.getList();
                }else{
                    this.currentPage=1;
                    this.pageSize=30;
                    //this.getfMou();
                }
                this.$nextTick(()=>{
                    this.getfMou();
                })

            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";

                }else if(type=='sou'){
                    this.vc_search=""
                }else if(type=='lx'){
                    this.vc_search=""
                }else if(type=='ly'){
                    this.i_invoice_source=0
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    invoiceNum:this.orderData.invoiceNum,
                    electronicNumber:this.orderData.electronicNumber,
                };
                var res = await API.listGlSq(param);
                if (res.code==1){
                    this.Edit=false;
                    res.data.list.map(item=>{
                        item.edit=false;
                    })
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
        }
    }
</script>
<style  lang="scss" scoped>
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }

    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>
